var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 167,
    viewBox: "0 0 226 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Discover_svg__filter0_d_353_4603)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.323,
    y: 21.323,
    width: 182.562,
    height: 124.354,
    rx: 14.552,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2.646
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.968 144.354l104.511-30.427v17.198c0 7.306-5.923 13.229-13.229 13.229H97.968z",
    fill: "#FD6020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.642 70.857c5.75 0 8.912 2.559 8.912 7.392a6.915 6.915 0 01-5.75 7.392l7.763 10.52h-6.038l-6.612-10.236h-.575V96.16h-4.887V70.857h7.187zm-2.3 11.657h1.438c3.162 0 4.6-1.422 4.6-3.98 0-2.275-1.438-3.696-4.6-3.696h-1.438v7.676zM158.494 96.16h13.799v-4.264h-8.912v-6.823h8.624v-4.265h-8.624v-5.686h8.912v-4.265h-13.799V96.16zm-14.375-8.244l-6.612-17.059h-5.175l10.637 25.872h2.588l10.637-25.872h-5.175l-6.9 17.059zm-58.36-4.265c0 7.108 5.75 13.078 12.938 13.078 2.3 0 4.312-.569 6.324-1.421V89.62c-1.437 1.706-3.449 2.844-5.75 2.844-4.6 0-8.336-3.412-8.336-7.961v-.569c-.288-4.549 3.45-8.529 8.05-8.813 2.299 0 4.599 1.137 6.036 2.843v-5.686c-1.725-1.137-4.024-1.422-6.037-1.422C91.51 70.29 85.76 76.26 85.76 83.651zm-8.911-3.127c-2.875-1.138-3.737-1.706-3.737-3.128.287-1.706 1.724-3.127 3.45-2.843 1.437 0 2.874.853 4.024 1.99l2.588-3.411c-2.013-1.706-4.6-2.843-7.188-2.843-4.024-.285-7.474 2.843-7.762 6.823v.284c0 3.412 1.438 5.402 6.037 6.824 1.15.284 2.3.853 3.45 1.421.863.569 1.438 1.422 1.438 2.559 0 1.99-1.725 3.696-3.45 3.696h-.288c-2.3 0-4.312-1.422-5.174-3.412l-3.163 3.128c1.725 3.127 5.175 4.833 8.625 4.833 4.6.284 8.337-3.128 8.625-7.676v-.853c-.288-3.412-1.725-5.118-7.475-7.392zM60.174 96.16h4.887V70.857h-4.887V96.16zM37.462 70.857h8.625c6.9.285 12.362 5.97 12.074 12.794 0 3.696-1.725 7.108-4.6 9.666-2.587 1.99-5.75 3.128-8.911 2.843h-7.188V70.857zm6.325 21.039c2.3.284 4.887-.569 6.612-1.99 1.725-1.706 2.588-3.98 2.588-6.54 0-2.274-.863-4.548-2.588-6.254-1.725-1.421-4.312-2.274-6.612-1.99H42.35v16.774h1.437z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.683 70.27c-7.187 0-13.224 5.687-13.224 13.079 0 7.107 5.75 13.078 13.224 13.362 7.475.284 13.224-5.686 13.512-13.078-.288-7.392-6.037-13.362-13.512-13.362z",
    fill: "#FD6020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Discover_svg__filter0_d_353_4603",
    x: 0,
    y: 0,
    width: 225.208,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_353_4603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_353_4603",
    result: "shape"
  })))));
}
export default SvgDiscover;